import React from 'react';
import { CheckCircle } from 'lucide-react';

export function DeliveredBadge({ date }) {
  if (!date) return null;
  const formatted = new Date(date).toLocaleDateString('fr-FR', {
    day: '2-digit', month: 'short', year: 'numeric'
  });
  return (
    <span data-testid="delivered-badge" className="animate-pulse inline-flex items-center gap-1 bg-emerald-500 text-white text-[10px] font-bold px-2 py-0.5 rounded">
      <CheckCircle size={11} /> Livré au client le {formatted}
    </span>
  );
}
